import { ELEMENT_DEFAULT, TElement } from '@udecode/plate';
import { Node } from 'slate';

export const checkForEmptySlateObject = (editorValue: TElement[]) => {
  return editorValue.filter((item) => {
    return (
      (item.type === ELEMENT_DEFAULT && Node.string(item).replace(/\s/g, '').length !== 0) ||
      item.type !== ELEMENT_DEFAULT
    );
  });
};
// to be merged with the above function
export const checkForEmptySlateObjectWithMention = (editorValue: TElement[]) => {
  return editorValue.filter((item) => {
    return (
      (item.type === ELEMENT_DEFAULT && Node.string(item).replace(/\s/g, '').length !== 0) ||
      (item.type === ELEMENT_DEFAULT && checkForOtherTypes(item?.children).length > 0) ||
      item.type !== ELEMENT_DEFAULT
    );
  });
};

const checkForOtherTypes = (children) => {
  return children.filter((item) => item?.type === 'mention');
};
